import { ref } from "vue";
import { Dark, setCssVar } from "quasar";

const isDarkMode = ref(localStorage.getItem("darkMode") === "true");

// Quasars brand-primärfärger bakas in i statiska CSS-regler vid boot, så
// att enbart override:a --q-primary via CSS räcker inte för q-btn flat-
// ikoner. setCssVar uppdaterar både regelvärdena och CSS-variabeln så
// alla färger flippar reaktivt.
const PRIMARY_LIGHT = "#1a1a1a";
const PRIMARY_DARK = "#f0ece4";

export function toggleDarkMode() {
  isDarkMode.value = !isDarkMode.value;
  localStorage.setItem("darkMode", isDarkMode.value);
  applyDarkMode(isDarkMode.value);
}

export function applyDarkMode(value) {
  if (value) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
  // Synka Quasars egna dark mode så q-dialog, q-input, q-table osv följer
  // sajtens dark mode. Utan detta är admin-modaler vita även när resten
  // av sajten är mörk.
  Dark.set(value);
  // Flippa Quasars primärfärg så svarta knappar/ikoner blir off-white
  // mot mörk bakgrund och vice versa.
  setCssVar("primary", value ? PRIMARY_DARK : PRIMARY_LIGHT);
}

export { isDarkMode };
